/* global axios */

import ApiClient from './ApiClient';

class ScheduledMessagesAPI extends ApiClient {
  constructor() {
    super('scheduled_messages', { accountScoped: true });
    this.conversationId = null;
  }

  get url() {
    return `${this.baseUrl()}/conversations/${this.conversationId}/scheduled_messages`;
  }

  get(conversationId) {
    this.conversationId = conversationId;
    return super.get();
  }

  create(conversationId, payload) {
    this.conversationId = conversationId;
    return super.create(payload);
  }

  update(conversationId, id, payload) {
    this.conversationId = conversationId;
    return super.update(id, payload);
  }

  delete(conversationId, id) {
    this.conversationId = conversationId;
    return super.delete(id);
  }

  createSequence(conversationId, payload) {
    this.conversationId = conversationId;
    return axios.post(`${this.url}/sequence`, payload);
  }

  deleteSequence(conversationId, sequenceId) {
    this.conversationId = conversationId;
    return axios.delete(`${this.url}/sequence/${sequenceId}`);
  }
}

export default new ScheduledMessagesAPI();
